import React, { Component } from 'react';
import ApplicantsTable from '../../../components/usermanagement/lender/ApplicantsTable';
import Search from '../../../components/Search';
import axios from "../../../util/axios";
import { trackPromise } from "react-promise-tracker";
import { Link } from "react-router-dom";
import CobrandSelector from "../../../components/cobrandselection/CobrandSelector";
import ApplicantModal from "../../../components/ApplicantModal";

class Applicants extends Component {

    constructor(props) {
        super(props);
        this.state = {
            usersLoaded: false, /* Temporary fix for spinner loading */
            userToken: JSON.parse(localStorage.getItem("userData")).token,
            showApplicantModal: false,
            applicant: null,
            applicantModalType: null,
		    users: [],
            searchTerm: '',
            cobrand: this.props.match
            ? this.getCobrandById(this.props.match.params.cobrandId)
            : JSON.parse(localStorage.getItem("userData")).cobrands[0],
            showBanner:false,
            rowsPerPage: 50
	    }
        this.handleApplicantClick = this.handleApplicantClick.bind(this);
        this.updateApplicantData = this.updateApplicantData.bind(this);
        this.handleCloseApplicantModal = this.handleCloseApplicantModal.bind(this);
    }

    getCobrandById(cobrandId) {
        var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands;
        var index = cobrands.findIndex(function(cobrand, i) {
          return cobrand.id.toString() === cobrandId;
        });
        return index > -1 ? cobrands[index] : cobrands[0];
    }

	componentDidMount() {
        trackPromise(
            axios.get('/api/user/getUsersList', {
                headers: {
                    Authorization: JSON.parse(localStorage.getItem("userData")).token,
                    "Cobrand-Id": this.state.cobrand.id
                }
            })
            .then(res => {
                this.setState({ users: res.data, usersLoaded: true }); /* Temporary fix for spinner loading */
            })
            .catch(err => {
                console.log(err);
            }) 
        );       
	}

    callbackfunction = (didCreateUser) => {
        this.setState({showBanner:didCreateUser});
    }

	handleChange = (e) => {
		this.setState({ searchTerm: e.target.value });
    }
    
	handleCreateUser = async event => {
        event.preventDefault();
        this.props.history.push({
            pathname:
              "/userMgmt/edit_1/" + this.state.cobrand.id
          });  
    };

    checkuser = (user) => {
        if ((user.username && user.username.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1)
            || (user.fname && user.fname.toString().indexOf(this.state.searchTerm) !== -1)
            || (user.lname && user.lname.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1)
            || (user.snapshotStatus && user.snapshotStatus.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1))
        {
            return user;
        }
    }

    handleApplicantClick(applicantModalType, applicant) {
        this.setState({ showApplicantModal: true, applicantModalType, applicant });
    }

    updateApplicantData() {
        //this.setState({ users: [] });
        console.log("update");
    }

    handleCloseApplicantModal() {
        this.setState({ showApplicantModal: false });
    }

	render() {
        const filteredUsers = [...this.state.users.filter(this.checkuser)
        ];
        /* Temporary fix for spinner loading */
		return (
            <React.Fragment>
                <div className="container main">
					<div className="row mt-4 mb-2">
						<div className="col-md-4 ml-auto">
							<CobrandSelector />
						</div>
					</div>
                    <div class="heading mt-2">Manage Applicants</div>
                    <div className="mb-4 text-right">
                            <Link
                                className="font-weight-bold text-center mt-2"
                                to={{ pathname: '/applicantMgmt/edit_1/' + this.state.cobrand.id}}
                            >
                                CREATE APPLICANT
                            </Link>
                    </div>
                    { this.state.showApplicantModal && 
                        <ApplicantModal 
                            modalType={this.state.applicantModalType}
                            updateApplicantData={this.updateApplicantData}
                            handleCloseApplicantModal={this.handleCloseApplicantModal}
                            applicant={this.state.applicant}
                            userToken={this.state.userToken}
                            cobrandId={this.state.cobrand.id}
                        />
                    }
                    <div className="row mt-2 mb-4 d-flex justify-content-end">
                        <div className="col col-md-5">
                         <Search searchTerm={this.handleChange} placeholder={'Search by Login Name, Name or Status'} />
                        </div>
                    </div>
                    { 
                        /* Temporary fix for spinner loading */
                        this.state.usersLoaded && <ApplicantsTable data={filteredUsers} paginationPerPage={this.state.rowsPerPage} handleApplicantClick={this.handleApplicantClick}  />
                    }
                </div>
            </React.Fragment>
		);
	}
}

export default Applicants;